module.exports = "pegasus/assets/themelp1/ebook/101.png";